export const MGMT_ORDER_REQUEST = "MGMT_ORDER_REQUEST";
export const MGMT_ORDER_SUCCESS = "MGMT_ORDER_SUCCESS";
export const MGMT_ORDER_FAIL = "MGMT_ORDER_FAIL";
